module.exports = __webpack_public_path__ + "static/media/New_K_F_Series-next_Broschuere_EN.0bfbb1e9.pdf";